import React, { Component } from 'react';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
import InfoIcon from '@material-ui/icons/Info';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField/index';
import { insertSubmit } from '../../../../../../services/InsertSubmit'
import Typography from '@material-ui/core/Typography';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CloseIcon from '@material-ui/icons/Close';

moment.locale('es')

class WindowModal extends Component {


    constructor(props) {
        super(props);
        var requiredOut = false
        var requiredError = false
        if (props.row.fuera === 0) {
            requiredOut = true
        }
        if (props.row.error === 0) {
            requiredError = true
        }
        sessionStorage.setItem("data", JSON.stringify(this.props.row))
        sessionStorage.setItem("prevData", JSON.stringify(this.props.row))


        this.state = {
            dataObjective: this.props.dataObjective,
            day: this.props.row.dia,
            perf: this.props.row.perf,
            error: this.props.row.error,
            out: this.props.row.fuera,
            sample: this.props.row.muestra,
            data: this.props.row,
            errorValue: false,
            average: this.props.row.tiempo,
            msg: ["Valores Ingresados deben tener como Resultado 100%"],
            indexmsg: 0,
            fieldChange: '',
            OutRequired: requiredOut,
            ErrorRequired: requiredError,
            sampleRequired: false,
            openPop: false,
            anchorPop: null,
            restore: true
        }
    }

    validateName = (type, value) => {
        if (isNaN(parseFloat(value))) {
            if (type === "perf") {
                this.setState({
                    validPerf: true
                });
            } else if (type === 'fuera') {
                this.setState({
                    validOut: true
                });
            } else if (type === 'error') {
                this.setState({
                    validError: true
                });
            } else if (type === 'muestra') {
                this.setState({
                    validSample: true
                });
            }
            else if (type === 'average') {
                this.setState({
                    validAverage: true
                });
            }

        }
    }



    handleFieldChange = (field, value) => {
        /* const {error, fieldChange, out, perf, sample}=this.state
        console.log(perf,out, error, sample, fieldChange); */
        if (field === "error") {
            this.setState({
                OutRequired: true,
                ErrorRequired: false,
                sampleRequired: true,
                errorValue: false,
                isRefreshError: true,
                isRefreshOut: false,
                error: value,
                fieldChange: field
            });

        } else if (field === "fuera") {
            this.setState({
                OutRequired: false,
                ErrorRequired: true,
                sampleRequired: true,
                errorValue: false,
                isRefreshError: false,
                isRefreshOut: true,
                out: value,
                fieldChange: field
            });

        } else if (field === "muestra") {
            this.setState({
                errorValue: false,
                isRefreshError: false,
                isRefreshOut: false,
                isRefreshSample: true,
                OutRequired: true,
                ErrorRequired: true,
                sampleRequired: false,
                sample: value,
                fieldChange: field
            });
        }
        else if (field === "average") {
            this.setState({
                average: value,
                fieldChange: field,
                restore: false
            });
        }

    }

    save = () => {
        const { day, error, out, perf, sample, dataObjective, average } = this.state
        var total = parseFloat((parseFloat(perf) + parseFloat(out) + parseFloat(error)).toFixed(0))
        if (total !== 100) {
            this.setState({
                errorValue: true
            });
        } else {
            //console.log("insert")
            //CUANDO LA FECHA SELECCIONADA CAE RANGO ENTRE MESES SE ESTABLECE A QUE MES CORRESPONDE DIA PARA GENERAR CACHE
            var start = (moment(this.props.dates.startDate))
            var end = (moment(this.props.dates.endDate))
            var dayStart = end.format("DD")
            var dateInsert = start.format("YYYY-MM")
            const dayCompare = day.substring(0, day.length - 1)
            if (parseInt(dayCompare) < parseInt(dayStart)) {
                dateInsert = end.format("YYYY-MM")
            }
            if (dayCompare.length === 1) {
                dayCompare = 0 + dayCompare
            }
            dateInsert = dateInsert + "-" + dayCompare + " 00:00:00"
            insertSubmit(day, (dataObjective.nodos.map(i => i.monitor_id).join(",")), dataObjective.objetivo_id, dataObjective.paso, dataObjective.sla_performance, 29, perf, error, out, sample, average, dateInsert).then(data => {
                this.props.handleCloseControl()
                this.setState({
                    errorValue: false
                });
            })
            this.props.handleControl(day)
            this.close()
        }
        sessionStorage.clear();
    }
    close = () => {
        sessionStorage.clear();
        this.props.handleCloseControl()
    }
    change = (e) => {
        const { day, error, fieldChange, out, perf, sample, average } = this.state
        //? Se formatea los datos ingresados
        let errorNum = parseFloat(error.toString().replace(",", "."))
        let outNum = parseFloat(out.toString().replace(",", "."))
        var dataSession = JSON.parse(sessionStorage.getItem("data"))
        var prevDataSession = JSON.parse(sessionStorage.getItem("prevData"))
        var newError = errorNum
        var newOut = outNum
        var newPerf = dataSession.perf
        var cantError = 0
        var cantOut = 0
        if (perf === newPerf) {
            newPerf = dataSession.perf
            if (fieldChange === "error") {
                newPerf = (dataSession.error - errorNum) + newPerf
            }
            if (fieldChange === "fuera") {
                newPerf = (dataSession.fuera - outNum) + newPerf
            }
            if (fieldChange === "muestra") {
                if (parseFloat(sample) > dataSession.muestra) {
                    cantError = parseFloat(dataSession.muestra * errorNum / 100)
                    cantOut = parseFloat(dataSession.muestra * outNum / 100)
                    newError = parseFloat((cantError * 100 / parseFloat(sample)).toFixed(1))
                    newOut = parseFloat((cantOut * 100 / parseFloat(sample)).toFixed(1))
                    newPerf = 100 - (newError + newOut)
                } else {
                    this.setState({
                        isRefreshError: false,
                        errorValue: true,
                        isRefreshOut: false,
                    });
                }
            }
        }
        else {
            newPerf = prevDataSession.perf
            if (fieldChange === "error") {
                newPerf = (prevDataSession.error - errorNum) + newPerf
            }
            if (fieldChange === "fuera") {
                newPerf = (prevDataSession.fuera - outNum) + newPerf
            }
            if (fieldChange === "muestra") {
                if (parseFloat(sample) > prevDataSession.muestra) {
                    cantError = parseFloat(prevDataSession.muestra * errorNum / 100)
                    cantOut = parseFloat(prevDataSession.muestra * outNum / 100)
                    newError = parseFloat((cantError * 100 / parseFloat(sample)).toFixed(1))
                    newOut = parseFloat((cantOut * 100 / parseFloat(sample)).toFixed(1))
                    newPerf = 100 - (newError + newOut)
                } else {
                    this.setState({
                        isRefreshError: false,
                        errorValue: true,
                        isRefreshOut: false,
                    });
                }
            }
        }
        
        
        var prevData = {
            dia: day,
            perf: newPerf,
            fuera: newOut,
            error: newError,
            muestra: sample,
            tiempo: average,
            
        }

        newPerf = parseFloat(newPerf.toFixed(1))
        if (newPerf < 100) {
            if (fieldChange === "muestra") {
                sessionStorage.setItem("prevData", JSON.stringify(prevData))
                this.setState({
                    OutRequired: true,
                    ErrorRequired: true,
                    isRefreshSample: false,
                    perf: newPerf,
                    out: newOut,
                    error: newError,
                    restore: false,
                    validPerf: false,
                    validOut: false,
                    validError: false,
                    validSample: false,
                    validAverage: false
                })
            } else {
                sessionStorage.setItem("prevData", JSON.stringify(prevData))
                this.setState({
                    perf: newPerf,
                    out: newOut,
                    error: newError,
                    sampleRequired: true,
                    OutRequired: false,
                    ErrorRequired: false,
                    isRefreshError: false,
                    isRefreshOut: false,
                    restore: false,
                    validPerf: false,
                    validOut: false,
                    validError: false,
                    validSample: false,
                    validAverage: false
                });
            }

        } else if (newPerf === 100) {
            this.setState({
                perf: 100,
                OutRequired: true,
                ErrorRequired: true,
                sampleRequired: true,
                isRefreshError: false,
                isRefreshOut: false,
            });
        } else {
            this.setState({
                perf: 100,
                isRefreshError: false,
                errorValue: true,
                isRefreshOut: false,
            });
        }
    }

    restoreBtn = (e) => {
        var dataSession = JSON.parse(sessionStorage.getItem("data"))
        this.setState({
            perf: dataSession.perf,
            out: dataSession.fuera,
            error: dataSession.error,
            sample: dataSession.muestra,
            average: dataSession.tiempo,
            OutRequired: false,
            ErrorRequired: false,
            sampleRequired: false,
            restore: false
        });

    }
    handlePopover = (event) => {
        this.setState(prevState => ({
            openPop: !prevState.openPop,
            anchorPop: event.currentTarget
        }));
    }


    render() {
        const { classes } = this.props
        const { validPerf, validOut, validError, validSample, validAverage, perf, out, error, day, sample, errorValue, average, msg, indexmsg,
            isRefreshOut, isRefreshError, isRefreshSample, OutRequired, ErrorRequired, sampleRequired, openPop, anchorPop, restore } = this.state
        //console.log('render window', isRefreshOut)
        //console.log(openPop)
        return (
            <Grid
                container
                spacing={1}
                style={{ backgroundColor: "white", width: "35%" }}
            >
                <Grid
                    item
                    xs={10}
                    sm={10}
                    md={10}
                    xl={10}
                    style={{ textAlign: "right" }}
                >
                    <Button onClick={this.handlePopover}><InfoIcon style={{ color: "#ff7800" }} /></Button>
                    <Popover
                        open={openPop}
                        anchor={anchorPop}
                        onClose={this.handlePopover}
                        style={{ width: "60%", inset: "-150px 150px 0px" }}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'center',
                        }}
                    >
                        <Grid
                            container
                            spacing={1}
                            style={{ backgroundColor: "#ff7800" }}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                                style={{ textAlign: "left", color: "white", padding: "25px" }}
                            >
                                <Typography variant="h5" style={{ padding: "4px" }}>INFORMACIÓN</Typography>
                                <Typography variant="h6" style={{ fontSize: "1rem" }}> Tabla que permite el cambio de Performance, a través de la
                                    modificacion de los parametros de error, fuera de sla y de muestra. </Typography>
                                <Typography variant="h6" style={{ fontSize: "1rem" }}>
                                    Al Modificar la muestra se deshabilitan los campos de fuera de sla y error,
                                    y al seleccionar cualquiera de estos campos se dehabilita el campo de muestra.
                                </Typography>
                                <Typography variant="h6" style={{ fontSize: "1rem" }}>Cuando se obtiene el total de 100% la tabla queda deshabilitada</Typography>

                            </Grid>
                        </Grid>
                    </Popover>
                </Grid>
                <Grid
                    item
                    xs={2}
                    sm={2}
                    md={2}
                    xl={2}
                    style={{ textAlign: "right" }}
                >
                    <Button onClick={this.close}><CloseIcon /></Button>
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center" }}
                >
                    <TextField
                        id="standard-read-only-input"
                        label="Día"
                        disabled
                        defaultValue={day}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center", paddingBottom: "5px" }}
                >
                    <TextField
                        label="Tiempo de respuesta Promedio"
                        varian="filled"
                        value={average}
                        onChange={event =>
                            this.handleFieldChange('average', event.target.value)
                        }
                        onBlur={event =>
                            this.validateName('average', event.target.value)
                        }
                        error={validAverage}
                        helperText={validAverage ? 'Por favor ingrese un numero válido' : ' '}
                        variant="outlined"
                        inputProps={{ maxLength: 40 }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center" }}
                >
                    <Button onClick={this.restoreBtn} className={classes.button} disabled={restore}>Restaurar</Button>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center" }}
                >
                    <TextField
                        label="Performance"
                        varian="filled"
                        value={perf}
                        onChange={event =>
                            this.handleFieldChange('perf', event.target.value)
                        }
                        disabled
                        onBlur={event =>
                            this.validateName('perf', event.target.value)
                        }
                        error={validPerf}
                        helperText={validPerf ? 'Por favor ingrese un numero válido' : ' '}
                        variant="outlined"
                        inputProps={{ maxLength: 40 }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center" }}
                >
                    <TextField
                        style={{ paddingRight: "10px" }}
                        label="Fuera de Sla"
                        varian="filled"
                        value={out}
                        onChange={event =>
                            this.handleFieldChange('fuera', event.target.value)
                        }
                        disabled={OutRequired}
                        onBlur={event =>
                            this.validateName('fuera', event.target.value)
                        }
                        error={validOut}
                        helperText={validOut ? 'Por favor ingrese un numero válido' : ' '}
                        variant="outlined"
                        inputProps={{ maxLength: 40 }}
                    />
                    {isRefreshOut ?
                        <Button value="fuera" className={classes.button} onClick={this.change}>Actualizar<ArrowForwardIosIcon /></Button>
                        : null}
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center" }}
                >
                    <TextField
                        label="Error"
                        varian="filled"
                        value={error}
                        style={{ paddingRight: "10px" }}
                        onChange={event =>
                            this.handleFieldChange('error', event.target.value)
                        }
                        disabled={ErrorRequired}
                        onBlur={event =>
                            this.validateName('error', event.target.value)
                        }
                        error={validError}
                        helperText={validError ? 'Por favor ingrese un numero válido' : ' '}
                        variant="outlined"
                        inputProps={{ maxLength: 40 }}
                    />
                    {isRefreshError ?
                        <Button value="error" className={classes.button} onClick={this.change}>Actualizar<ArrowForwardIosIcon /></Button>
                        : null}

                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center" }}
                >
                    <TextField
                        label="Muestra"
                        varian="filled"
                        style={{ paddingRight: "10px" }}
                        value={sample}
                        onChange={event =>
                            this.handleFieldChange('muestra', event.target.value)
                        }
                        disabled={sampleRequired}
                        onBlur={event =>
                            this.validateName('muestra', event.target.value)
                        }
                        error={validSample}
                        helperText={validSample ? 'Por favor ingrese un numero válido' : ' '}
                        variant="outlined"
                        inputProps={{ maxLength: 40 }}
                    />
                    {isRefreshSample ?
                        <Button value="sample" className={classes.button} onClick={this.change}>Actualizar<ArrowForwardIosIcon /></Button>
                        : null}
                </Grid>
                {errorValue ?
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{ textAlign: "center" }}
                    >
                        <Typography style={{ backgroundColor: "red", color: "white" }}>{msg[indexmsg]}</Typography>
                    </Grid> : null
                }
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center" }}
                >
                    <Button onClick={this.save} className={classes.button}>Guardar</Button>
                </Grid>

            </Grid>
        )

    }
}



//export default (Movistar);

export default compose(withStyles(styles))(WindowModal);


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/ControlObjective/WindowModal/index.jsx